/* import __COLOCATED_TEMPLATE__ from './suggestion-card.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    suggestion: TaskSuggestion;
  };
}

export default class SuggestionCard extends Component<Signature> {
  @service declare intl: IntlService;
  @tracked isApiDocsSideDrawerOpen = false;
  @tracked isEditingGuidance = false;
  @tracked openSectionId: string | null = null;

  @action
  onOpenSectionChange(sectionId: string) {
    this.openSectionId = sectionId;
  }

  @action
  openApiSidePanel() {
    this.isApiDocsSideDrawerOpen = true;
  }

  @action
  closeApiSidePanel() {
    this.isApiDocsSideDrawerOpen = false;
  }

  @action
  startEditingGuidance() {
    this.isEditingGuidance = true;
  }

  @action
  cancelEditingGuidance() {
    this.isEditingGuidance = false;
  }

  get topicsString() {
    return this.args.suggestion.topicNameList.join(', ') || '';
  }

  get difficultyScoreText() {
    let score = this.args.suggestion.implementationDifficultyScore;
    if (!score) {
      return '';
    }
    if (score <= 2) {
      return this.intl.t('automation.analyze.task-suggestions.effort-score.low');
    } else if (score <= 4) {
      return this.intl.t('automation.analyze.task-suggestions.effort-score.medium');
    } else {
      return this.intl.t('automation.analyze.task-suggestions.effort-score.high');
    }
  }

  get difficultyScoreClasses() {
    let score = this.args.suggestion.implementationDifficultyScore;
    if (!score) {
      return '';
    }
    if (score <= 2) {
      return 'bg-beta-container border-beta-border';
    } else if (score <= 4) {
      return 'bg-notice-container border-notice-border';
    } else {
      return 'bg-error-container border-error-border';
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TaskSuggestions::SuggestionCard': typeof SuggestionCard;
    'reporting/automation/fin-ai-agent/analyze/task-suggestions/suggestion-card': typeof SuggestionCard;
  }
}
